// extracted by mini-css-extract-plugin
export var container = "TextBlock-module--container--9958c";